import React from 'react'
import { Link } from 'react-router-dom'
import { withNamespaces } from 'react-i18next'

export const SliderCard = ({ className, imgLink, title, descr, linkTo, t, ...props }) => {
    return <div className={`c-card-holder ${className}`}>
        <div className='c-card'>
            <img className='c-card__img' src={imgLink} alt={title} />
            <div className='c-card__overlay'>
                <div className='c-card__content'>
                    <div className='u-text--large u-margin-bottom@desktop u-margin-bottom-small'>{title}</div>
                    <div className='u-margin-bottom@desktop u-margin-bottom-small'>{descr}</div>
                    <Link to={linkTo} className='c-btn c-btn--finch'>{t('general.viewMore')} &#8594;</Link>
                </div>
            </div>
        </div>
    </div>
}

export default withNamespaces()(SliderCard)



// WEBPACK FOOTER //
// ./src/components/SliderCard.js